"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculationFragments = exports.calculationFragment = void 0;
const comment_1 = require("./comment");
const customer_1 = require("./customer");
const financing_1 = require("./financing");
const reference_1 = require("./reference");
const vehicle_1 = require("./vehicle");
exports.calculationFragment = `
  fragment calculation on Calculation {
    id
    comments {
      ...comment
    }
    customer {
      ...customer
    }
    customerType
    financing {
      ...financing
    }
    financeProvider
    financingType
    history {
      ...financing
    }
    options
    order {
      orderReference {
        ...reference
      }
    }
    reference {
      ...reference
    }
    timestamp
    vehicles {
      ...vehicle
    }
  }
`;
exports.calculationFragments = `
  ${exports.calculationFragment}
  ${comment_1.commentFragment}
  ${customer_1.customerFragment}
  ${financing_1.financingFragmentFull}
  ${financing_1.financingRequestFragment}
  ${reference_1.referenceFragment}
  ${vehicle_1.vehicleFragment}
  ${vehicle_1.vehicleConfigurationFragment}
  ${vehicle_1.vehicleModelFragment}
  ${vehicle_1.vehicleInventoryFragment}
  ${vehicle_1.vehicleStatusFragment}
`;
//# sourceMappingURL=calculation.js.map